import React from 'react'

export const Card2 = () => {
  return (
    <div>
         <div className="card-container">
            
<div className="card card2">
    <img src="https://superdesk-fidelity.s3-eu-west-2.amazonaws.com/sd-fidelity/20230315140316/63624e622c07997b4910e172a00171a6df380b53e50253e989350972bb7f386c.png" alt="Image 1"/>
    <div className="card-description2">
    <p  style={{
        fontSize:'1rem',
        color:'#686363'
      }}><span style={{
        color:'#ce4513',
        marginRight:'2rem',
        fontSize:'1.5rem'
      }}> <b>Podcast</b></span>        36 min listen</p>
      <p>Rich Pickings podcast: Looking for cracks in the system after SVB.</p>
     
      <p
       style={{
        fontSize:'1rem'
      }}
      ><span
      style={{
        fontSize:'1rem'
      }}
      ><b>Gita Bal </b></span>+ 5 others <br />

15 March 2023</p>
    </div>

  </div>
  <div className="card card2" 
  
  >
    <img src="https://superdesk-fidelity.s3-eu-west-2.amazonaws.com/sd-fidelity/2023022810020/d23e07d535c001616cc133a41ad2534fc015832cbce78b49ff9e8b2202cee3d2.png"  alt="Image 2"/>
    <div className="card-description2">
      <p  style={{
        fontSize:'1rem',
        color:'#686363'
      }}><span style={{
        color:'#ce4513',
        marginRight:'2rem',
        fontSize:'1.5rem'
      }}> <b>Podcast</b></span>15 min listen</p>
      <p>CIO podcast: What next for China and what investors might have missed



</p>
    
      <p
       style={{
        fontSize:'1rem'
      }}
      ><span
      style={{
        fontSize:'1rem'
      }}
      ><b>Andrew McCaffery </b></span>+ 2 others <br />

28 February 2023</p>
    </div>
  </div>
  <div className="card card2">
    <img src="https://superdesk-fidelity.s3-eu-west-2.amazonaws.com/sd-fidelity/20230221110232/0aaafd8e35c6fdeacb93a5adb937297bf7e8d7d6c96f648fad70d7ed8543f08c.jpg" alt="Image 3"/>
    <div className="card-description2">
       <p  style={{
        fontSize:'1rem',
        color:'#686363'
      }}><span style={{
        color:'#ce4513',
        marginRight:'2rem',
        fontSize:'1.5rem'
      }}> <b>Podcast</b></span>41 min listen</p>
      <p>Fidelity experts on the war in Ukraine and its far-reaching impacts.</p>
    


<p
       style={{
        fontSize:'1rem'
      }}
      ><span
      style={{
        fontSize:'1rem'
      }}
      ><b>      Ned Salter
      </b></span>+ 4 others <br />

22 February 2023</p>
    </div>
  </div>
</div>

    </div>
  )
}
